export function isEqual(
  obj1: any,
  obj2: any,
  ignoreKeys: string[] = [
    'startX',
    'startY',
    'width',
    'height',
    'lockPath',
    'isActive',
    '_sortNum',
    'isLocked',
    // 'model_front_edge',
    // 'smoothEdge',
    // 'doorOpenSide',
  ]
): boolean {
  if (obj1 === obj2) return true
  if (typeof obj1 !== typeof obj2) {
    return false
  }
  if (typeof obj1 !== 'object' || obj1 === null || obj2 === null)
    return obj1 === obj2

  // 数组处理
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) {
      return false
    }
    for (let i = 0; i < obj1.length; i++) {
      if (!isEqual(obj1[i], obj2[i], ignoreKeys)) return false
    }
    return true
  }

  // 对象处理
  const keys1 = Object.keys(obj1).filter(
    (k) => !ignoreKeys.includes(k) && obj1[k] !== undefined
  )
  const keys2 = Object.keys(obj2).filter(
    (k) => !ignoreKeys.includes(k) && obj2[k] !== undefined
  )
  if (keys1.length !== keys2.length) {
    return false
  }
  for (const key of keys1) {
    if (!keys2.includes(key)) return false
    if (!isEqual(obj1[key], obj2[key], ignoreKeys)) return false
  }
  return true
}
